module.exports = __webpack_public_path__ + "img/logo@2x.c876b3a0.png";